import * as React from 'react';

import { JackpotType } from '@/types/gameTypes';

import JackpotLayer from './JackpotLayer';
import styles from './JackpotLayerGameTile.module.scss';

type JackpotLayerGameTileProps = JackpotType;

const GT_JACKPOT_TICKER_TEST_ATTR = 'gt-jackpot_ticker';

const JackpotLayerGameTile = (jackpot: JackpotLayerGameTileProps) => (
  <div className={styles.container} data-testid={GT_JACKPOT_TICKER_TEST_ATTR}>
    <JackpotLayer {...jackpot} componentType={'gameTile'} />
  </div>
);

export default JackpotLayerGameTile;
